/* RESPONSIBLE TEAM: team-data-foundations */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import cached from 'embercom/lib/cached-decorator';
import type { ExternalPlanWireFormat } from 'embercom/objects/inbox/external-plan';
import ajax from 'embercom/lib/ajax';
import { captureException } from 'embercom/lib/sentry';
import type Session from 'embercom/services/session';

export default class PlansApi extends Service {
  @service declare session: Session;

  async planName(id: string) {
    let plan = await this.findSelectedPlan(id);
    return plan.name;
  }

  @cached({ max: 50, ttl: 1000 * 60 * 5 })
  async findSelectedPlan(id: string) {
    let plan = (await ajax({
      url: `/ember/external_plans/${id}`,
      data: {
        app_id: this.session.workspace.id,
      },
    })) as ExternalPlanWireFormat;
    return plan;
  }

  @cached({ max: 50, ttl: 1000 * 60 * 5 })
  async searchPlans(inputText: string): Promise<ExternalPlanWireFormat[] | null> {
    if (!inputText.trim()) {
      return null;
    }

    try {
      let response = (await ajax({
        url: '/ember/external_plans/search',
        data: {
          app_id: this.session.workspace.id,
          name: inputText,
        },
      })) as { external_plans: ExternalPlanWireFormat[] };
      return response.external_plans;
    } catch (error) {
      captureException(error);
      return null;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    plansApi: PlansApi;
    'plans-api': PlansApi;
  }
}
